/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { animated } from '@react-spring/web';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { styles } from './badge.styles';

export enum BadgeSize {
    SMALL = 'small',
    REGULAR = 'regular',
    LARGE = 'large',
    XL = 'xl',
}

export enum BadgeColour {
    FLAME = 'flame',
    SOL = 'sol',
    MIDNIGHT = 'midnight',
    WHITE = 'white',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface BadgeProps {
    /**
     * Colour to set the components background
     * 1. FLAME
     * 2. MIDNIGHT
     * 3. WHITE
     *
     * @default FLAME
     */
    colour?: BadgeColour;

    /**
     * The size of the button
     *
     * @default SMALL;
     */
    size?: BadgeSize;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;

    /**
     * animation props
     */
    animation?: any;

    /**
     * Children
     */
    children?: ReactNode;

    'data-id'?: string;
}

const StyledBadge = styled(animated.div).withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const Badge: FunctionComponent<BadgeProps> = ({
    animation,
    colour = BadgeColour.FLAME,
    size = BadgeSize.SMALL,
    children,
    'data-id': dataId = 'badge',
    ...otherProps
}: BadgeProps) => {
    return (
        <StyledBadge
            colour={colour}
            size={size}
            style={animation}
            data-id={dataId}
            {...otherProps}
        >
            <span
                className="badge-text-container"
                data-id={`${dataId}__content`}
            >
                {children}
            </span>
        </StyledBadge>
    );
};
